import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function ThirtyfiveSeaterBusOnRentInShirdi() {



    const cardData = {





keyword: "35 Seater Bus on Rent in Shirdi",
headingDescription: "Sai Shirdi Cab provides 35 seater bus rental in Shirdi for large groups looking for convenient and coordinated outstation transportation. This bus is a practical option for family tours, pilgrimage groups, school and college trips, corporate outings, wedding functions, social events, and multi-day Maharashtra or interstate journeys. Instead of arranging several smaller vehicles, groups can travel together in one spacious 35 seater bus with an organized pickup and drop plan. Sai Shirdi Cab can arrange one-way trips, round trips, return journeys, sightseeing tours, and customized multi-destination travel from Shirdi according to the group itinerary. With a dedicated driver and group-focused travel arrangements, the service helps make long-distance journeys from Shirdi more comfortable, manageable, and convenient.",

topPlaces: [
{
title: "Saputara",
description: "Saputara is a refreshing outstation destination for groups traveling from Shirdi for a weekend break, family vacation, college tour, or organized sightseeing trip. A 35 seater bus gives larger groups the convenience of traveling together without splitting passengers between multiple cars. Sai Shirdi Cab can arrange a suitable bus journey with planned pickup, sightseeing stops, and return travel according to the group's schedule."
},
{
title: "Shani Shingnapur",
description: "Shani Shingnapur is well suited for organized pilgrimage groups departing from Shirdi. A 35 seater bus on rent provides enough seating for devotees, families, and tour groups traveling together on a common itinerary. Sai Shirdi Cab can coordinate transportation for temple visits, group pickups, return journeys, and combined religious tours covering other destinations in Maharashtra."
},
{
title: "Pune",
description: "Pune is a useful outstation route from Shirdi for corporate groups, educational tours, family travel, events, and extended sightseeing programs. For larger groups, a 35 seater bus offers a convenient alternative to managing several separate cabs. Sai Shirdi Cab can organize the trip with flexible departure arrangements and suitable travel plans for one-way or round-trip requirements."
},
{
title: "Bhandardara",
description: "Bhandardara attracts groups looking for a peaceful nature-oriented trip from Shirdi. Families, friends, corporate teams, and student groups can benefit from the convenience of a 35 seater bus when traveling together. Sai Shirdi Cab provides group transportation that can accommodate sightseeing plans, multiple pickup requirements, and return travel while keeping the entire group on one coordinated route."
},
{
title: "Aurangabad",
description: "Aurangabad, now Chhatrapati Sambhajinagar, is a valuable outstation choice for heritage tours, family trips, educational excursions, and pilgrimage itineraries from Shirdi. A 35 seater bus is suitable for groups that want to travel together while visiting important historical and cultural attractions. Sai Shirdi Cab can arrange transportation for direct journeys as well as multi-stop tours around the region."
},
{
title: "Mahabaleshwar",
description: "Mahabaleshwar works well for larger groups planning a holiday or weekend tour from Shirdi. Renting a 35 seater bus through Sai Shirdi Cab allows families, friends, and organized tour groups to remain together during the journey and sightseeing schedule. The service can be planned for round trips, multi-day stays, and itineraries that include nearby hill-station attractions."
},
{
title: "Trimbakeshwar",
description: "Trimbakeshwar is a popular option for religious groups planning an outstation pilgrimage from Shirdi. With a 35 seater bus, larger groups can complete the journey together with a common pickup, travel route, and return plan. Sai Shirdi Cab can support group pilgrimage programs and customized itineraries that combine Trimbakeshwar with other spiritual destinations."
},
{
title: "Goa",
description: "Goa is an ideal long-distance destination for groups traveling from Shirdi for vacations, celebrations, college trips, family holidays, and group tours. A 35 seater bus provides a practical shared-travel solution for a larger number of passengers and reduces the need for multiple vehicles. Sai Shirdi Cab can arrange one-way, round-trip, or multi-day bus travel based on the group's preferred itinerary."
},
{
title: "Bhimashankar",
description: "Bhimashankar can be included in a group pilgrimage or weekend travel plan starting from Shirdi. A 35 seater bus is especially useful when families, devotees, or organized groups want to travel together and maintain a coordinated schedule. Sai Shirdi Cab can arrange transportation for direct trips or combined routes connecting Bhimashankar with other Maharashtra pilgrimage destinations."
},
{
title: "Nashik",
description: "Nashik is a versatile outstation destination from Shirdi for pilgrimage programs, family tours, corporate travel, and sightseeing groups. A 35 seater bus rental from Sai Shirdi Cab provides a convenient option for larger groups that prefer shared transportation throughout the journey. The trip can also be customized to include nearby religious, cultural, and leisure destinations depending on the planned itinerary."
}
],









"services": [
{
"name": "35 Seater Bus on Rent in Shirdi",
"description": "35 Seater Bus on Rent in Shirdi is a convenient choice for large groups traveling together for local trips, sightseeing, pilgrimages, and outstation journeys. Vehicles can be arranged according to the travel schedule, pickup location, passenger requirements, luggage space, and trip duration."
},
{
"name": "35 Seater Bus Rental Shirdi",
"description": "35 Seater Bus Rental Shirdi offers spacious group transportation for families, organizations, schools, and tour groups. Travelers can plan comfortable journeys with suitable pickup and drop locations, flexible travel schedules, and options for one-way or return trips."
},
{
"name": "35 Seater Bus Hire Shirdi",
"description": "35 Seater Bus Hire Shirdi provides a practical travel solution when multiple passengers need to travel in the same vehicle. It is suitable for sightseeing tours, religious visits, corporate travel, weddings, events, and long-distance group transportation."
},
{
"name": "35 Seater Tourist Bus Shirdi",
"description": "35 Seater Tourist Bus Shirdi is ideal for group sightseeing and planned tours around Shirdi and nearby destinations. The spacious seating arrangement allows travelers to stay together while enjoying an organized journey with convenient pickup and drop services."
},
{
"name": "35 Seater Bus Booking Shirdi",
"description": "35 Seater Bus Booking Shirdi makes it easier to arrange group transportation in advance for planned journeys. Customers can select travel dates, pickup points, destinations, vehicle requirements, and journey types according to their itinerary."
},
{
"name": "35 Seater Bus with Driver Shirdi",
"description": "35 Seater Bus with Driver Shirdi provides a convenient option for groups that prefer chauffeur-driven transportation. A professional driver can handle the route and driving requirements while passengers travel together comfortably for local or outstation trips."
},
{
"name": "35 Seater Bus for Outstation Shirdi",
"description": "35 Seater Bus for Outstation Shirdi is suitable for large groups planning travel from Shirdi to nearby cities, tourist destinations, and pilgrimage locations. The service can be arranged for customized itineraries, multiple stops, one-way travel, or return journeys."
},
{
"name": "35 Seater Bus for Family Trip Shirdi",
"description": "35 Seater Bus for Family Trip Shirdi offers comfortable group transportation for extended families traveling together. With ample seating and space for luggage, families can plan sightseeing tours, religious visits, vacations, and outstation journeys with convenient travel arrangements."
},
{
"name": "35 Seater Bus for Wedding Shirdi",
"description": "35 Seater Bus for Wedding Shirdi helps transport relatives, guests, and wedding groups between hotels, venues, railway stations, and other locations. It provides an organized travel option for wedding functions, ceremonies, receptions, and related guest transportation."
},
{
"name": "35 Seater Bus for Corporate Trip Shirdi",
"description": "35 Seater Bus for Corporate Trip Shirdi is designed for companies arranging transportation for employees, meetings, conferences, team outings, and business events. Group travel can be planned around office schedules, pickup locations, destinations, and required journey timings."
},
{
"name": "35 Seater Bus for School Trip Shirdi",
"description": "35 Seater Bus for School Trip Shirdi is a suitable group travel option for educational tours, excursions, field visits, and planned school outings. Schools can coordinate transportation based on the number of students, teachers, pickup points, destination, and trip schedule."
},
{
"name": "35 Seater Bus for Pilgrimage Shirdi",
"description": "35 Seater Bus for Pilgrimage Shirdi provides group transportation for devotees visiting religious destinations from Shirdi. It can be arranged for temple tours, multi-destination pilgrimage routes, family groups, and organized religious journeys with flexible travel plans."
},
{
"name": "35 Seater Bus for Events Shirdi",
"description": "35 Seater Bus for Events Shirdi offers dependable group transportation for social functions, cultural programs, exhibitions, conferences, parties, and other gatherings. Guests can travel together between designated pickup points, event venues, hotels, and return locations."
},
{
"name": "35 Seater AC Bus Shirdi",
"description": "35 Seater AC Bus Shirdi provides a spacious and comfortable travel option for groups requiring air-conditioned transportation. It is suitable for sightseeing, family tours, corporate outings, pilgrimage trips, weddings, and longer journeys from Shirdi."
},
{
"name": "35 Seater Luxury Bus Shirdi",
"description": "35 Seater Luxury Bus Shirdi is an option for groups looking for a more comfortable and premium travel experience. The spacious vehicle can be arranged for special occasions, corporate programs, family tours, weddings, events, and outstation travel."
},
{
"name": "35 Seater Bus One Way Shirdi",
"description": "35 Seater Bus One Way Shirdi is convenient for groups traveling from Shirdi to another destination without requiring the vehicle for the return journey. It can be planned according to the preferred pickup point, destination, departure schedule, passenger count, and luggage needs."
},
{
"name": "35 Seater Bus Round Trip Shirdi",
"description": "35 Seater Bus Round Trip Shirdi is suitable for groups planning a complete journey from Shirdi to a destination and back. Travelers can organize return transportation around their sightseeing plans, event timings, pilgrimage schedule, or vacation itinerary."
},
{
"name": "35 Seater Bus Airport Transfer Shirdi",
"description": "35 Seater Bus Airport Transfer Shirdi helps larger groups coordinate transportation between Shirdi and nearby airports. It is useful for families, corporate groups, tour parties, and organized travelers who need shared airport pickup or drop services with sufficient seating and luggage capacity."
},
{
"name": "affordable 35 Seater Bus Rental Shirdi",
"description": "Affordable 35 Seater Bus Rental Shirdi offers a practical way for large groups to manage transportation costs while traveling together. Rental arrangements can be planned according to the journey distance, travel duration, route, passenger requirements, and one-way or round-trip schedule."
},
{
"name": "best 35 Seater Bus Hire Shirdi",
"description": "Best 35 Seater Bus Hire Shirdi is suitable for travelers searching for spacious and dependable group transportation in Shirdi. It can support different travel requirements including family tours, corporate trips, weddings, pilgrimages, events, sightseeing, and outstation journeys."
},
{
"name": "Sai Shirdi Cabs",
"description": "Sai Shirdi Cabs provides 35 seater bus rental and group transportation services in Shirdi for local and outstation travel. Customers can arrange suitable vehicles for family trips, pilgrimages, weddings, corporate programs, school tours, airport transfers, events, and customized journeys."
}
],
"tableData": [
["35 Seater Bus on Rent in Shirdi", "35 Seater Bus Rental Shirdi"],
["35 Seater Bus Hire Shirdi", "35 Seater Tourist Bus Shirdi"],
["35 Seater Bus Booking Shirdi", "35 Seater Bus with Driver Shirdi"],
["35 Seater Bus for Outstation Shirdi", "35 Seater Bus for Family Trip Shirdi"],
["35 Seater Bus for Wedding Shirdi", "35 Seater Bus for Corporate Trip Shirdi"],
["35 Seater Bus for School Trip Shirdi", "35 Seater Bus for Pilgrimage Shirdi"],
["35 Seater Bus for Events Shirdi", "35 Seater AC Bus Shirdi"],
["35 Seater Luxury Bus Shirdi", "35 Seater Bus One Way Shirdi"],
["35 Seater Bus Round Trip Shirdi", "35 Seater Bus Airport Transfer Shirdi"],
["affordable 35 Seater Bus Rental Shirdi", "best 35 Seater Bus Hire Shirdi"],
["Sai Shirdi Cabs", "35 Seater Bus on Rent in Shirdi"]
]
,








whychoose: [ 
    {  
        WhyChooseheading: "35 Seater Bus on Rent in Shirdi for Group Travel",  
        WhyChoosedescription: "Sai Shirdi Cabs provides 35 Seater Bus rental services in Shirdi for pilgrimage groups, families, tourists, school and college groups, corporate teams, wedding guests, and other large groups. A 35 Seater Bus can be arranged for Sai Baba Darshan, Shirdi sightseeing, religious tours, events, airport and railway station transfers, outstation journeys, and multi-day group travel."  
    },  
    {  
        WhyChooseheading: "Spacious Bus Transportation for Large Groups",  
        WhyChoosedescription: "A 35 Seater Bus offers a practical option for larger groups that want to travel together instead of coordinating several smaller vehicles. Group transportation can be planned between hotels, temples, railway stations, airports, event venues, sightseeing locations, and other destinations while allowing passengers to stay together throughout the journey."  
    },  
    {  
        WhyChooseheading: "35 Seater Bus for Sai Baba Darshan",  
        WhyChoosedescription: "Devotees travelling to Shirdi with a large group can hire a 35 Seater Bus for Sai Baba Darshan and visits to nearby religious destinations. The bus can support organized group movement between accommodation, temple areas, planned pilgrimage stops, and other locations included in the group's travel schedule."  
    },  
    {  
        WhyChooseheading: "35 Seater Bus Rental for Shirdi Sightseeing",  
        WhyChoosedescription: "Families and tour groups can rent a 35 Seater Bus for sightseeing in Shirdi and nearby attractions. Multiple destinations can be included in the travel plan according to the group's preferred places, available time, pickup location, sightseeing requirements, and planned departure and return schedule."  
    },  
    {  
        WhyChooseheading: "Airport & Railway Station Transfers for Groups",  
        WhyChoosedescription: "A 35 Seater Bus can be arranged for group pickup and drop services involving airports and railway stations around Shirdi. This option can make coordinated transportation easier when many passengers arrive or depart together, with transfers planned between the station, airport, hotels, temples, venues, and other required locations."  
    },  
    {  
        WhyChooseheading: "35 Seater Bus Hire for Weddings & Events",  
        WhyChoosedescription: "Families, event organizers, and businesses can book a 35 Seater Bus for weddings, receptions, religious functions, corporate events, conferences, family gatherings, and other occasions in Shirdi. Guest transportation can be organized between hotels, event venues, railway stations, parking areas, and other locations according to the event schedule."  
    },  
    {  
        WhyChooseheading: "Outstation & Multi-Day Tours from Shirdi",  
        WhyChoosedescription: "A 35 Seater Bus can be considered for group journeys from Shirdi to destinations such as Nashik, Mumbai, Pune, Aurangabad, Trimbakeshwar, Shani Shingnapur, Bhimashankar, and other tourist or pilgrimage locations. Extended family trips, religious circuits, corporate tours, and multi-city itineraries can be planned based on the group's route and travel duration."  
    },  
    {  
        WhyChooseheading: "Book 35 Seater Bus on Rent in Shirdi with Sai Shirdi Cabs",  
        WhyChoosedescription: "Share your pickup location, destination, travel date, passenger count, luggage requirements, rental duration, sightseeing or event plans, and one-way or round-trip requirement with Sai Shirdi Cabs. Providing the complete travel schedule helps in planning a suitable 35 Seater Bus arrangement for your group journey."  
    }  
]  


};

const faqData = [
{
question: "Can I rent a 35 Seater Bus in Shirdi?",
answer: "Yes, Sai Shirdi Cabs provides 35 Seater Bus rental services in Shirdi for pilgrimage groups, families, tourists, corporate teams, wedding guests, school groups, and other large groups."
},
{
question: "Is a 35 Seater Bus suitable for Sai Baba Darshan?",
answer: "Yes, a 35 Seater Bus can be arranged for large groups visiting Sai Baba Temple and nearby pilgrimage destinations according to their planned travel itinerary."
},
{
question: "Can I book a 35 Seater Bus for Shirdi sightseeing?",
answer: "Yes, groups can book a private 35 Seater Bus for Shirdi sightseeing and nearby attractions based on their preferred destinations, travel duration, and sightseeing schedule."
},
{
question: "Can I book a 35 Seater Bus for airport transfers?",
answer: "Yes, a 35 Seater Bus can be arranged for group airport pickup and drop services according to flight schedules, passenger requirements, luggage needs, and the required pickup or drop location."
},
{
question: "Can I book a 35 Seater Bus from Shirdi Railway Station?",
answer: "Yes, group railway station pickup and drop services can be arranged with a 35 Seater Bus according to train schedules and the transportation requirements of your group."
},
{
question: "Can I rent a 35 Seater Bus for a wedding in Shirdi?",
answer: "Yes, a 35 Seater Bus can be booked for wedding guests, family members, receptions, religious functions, and other event transportation requirements in Shirdi."
},
{
question: "Can I use a 35 Seater Bus for outstation travel from Shirdi?",
answer: "Yes, the bus can be booked for outstation group journeys from Shirdi to different cities, tourist destinations, religious places, and other locations according to your planned route."
},
{
question: "Can I rent a 35 Seater Bus for multiple days?",
answer: "Yes, multi-day 35 Seater Bus rental arrangements can be discussed for extended pilgrimage tours, sightseeing trips, family vacations, corporate tours, group excursions, and multi-city journeys."
},
{
question: "Can a 35 Seater Bus be used for corporate group travel?",
answer: "Yes, companies can consider a 35 Seater Bus for employee transportation, corporate events, conferences, meetings, group outings, official tours, and other business travel requirements depending on the group size and itinerary."
},
{
question: "How can I book a 35 Seater Bus on Rent in Shirdi?",
answer: "Share your pickup point, destination, travel date, passenger count, luggage details, rental duration, sightseeing or event requirements, and one-way or return preference with Sai Shirdi Cabs to proceed with the 35 Seater Bus booking."
}
];

const testimonials = [
{
id: 1,
name: "Mr. Amit Deshpande",
feedback: "We rented a 35 Seater Bus in Shirdi for our pilgrimage group and used it for Sai Baba Darshan and nearby sightseeing. Having everyone travel in one vehicle made group coordination much easier throughout the trip.",
rating: 5
},
{
id: 2,
name: "Mrs. Neha Kulkarni",
feedback: "Our family group booked a 35 Seater Bus for an event in Shirdi. The larger vehicle was convenient for moving guests between the hotel, venue, and other planned locations without arranging multiple cars.",
rating: 5
}
];








    const Images = [
        { place: "/images/keyword/1.jpg", text: "Nagarsol to Shirdi Cab", link: "Nagarsol-to-Shirdi-Cab" },
        { place: "/images/keyword/2.jpg", text: "Shirdi Cab Service", link: "Shirdi-Cab-Service" },
        { place: "/images/keyword/3.jpg", text: "Shirdi to Shani Shingnapur Cab", link: "Shirdi-to-Shani-Shingnapur-Cab" },
        { place: "/images/keyword/4.jpg", text: "Shirdi to Grishneshwar Cab", link: "Shirdi-to-Grishneshwar-Cab" },
        { place: "/images/keyword/5.jpg", text: "Shirdi to Manmad Cab", link: "Shirdi-to-Manmad-Cab" },
        { place: "/images/keyword/6.jpg", text: "Shirdi to Lonavala Cab", link: "Shirdi-to-Lonavala-Cab" },
        { place: "/images/keyword/7.jpg", text: "Shirdi to Mahabaleshwar Cab", link: "Shirdi-to-Mahabaleshwar-Cab" },
        { place: "/images/keyword/8.jpg", text: "Shirdi to Ashtavinayak Darshan Package", link: "Shirdi-to-Ashtavinayak-Darshan-Package" },
        { place: "/images/keyword/9.jpg", text: "Shirdi to Saptashrungi Cab", link: "Shirdi-to-Saptashrungi-Cab" },
        { place: "/images/keyword/10.jpg", text: "Shirdi Tour Package", link: "Shirdi-Tour-Package" },
        { place: "/images/keyword/11.jpg", text: "Best Taxi Service in Shirdi", link: "Best-Taxi-Service-in-Shirdi" },
        { place: "/images/keyword/12.jpg", text: "Shirdi Airport Cab Service", link: "Shirdi-Airport-Cab-Service" },
        { place: "/images/keyword/13.jpg", text: "Online Cab Booking Shirdi", link: "Online-Cab-Booking-Shirdi" },
        { place: "/images/keyword/14.jpg", text: "Best Travel Agency in Shirdi", link: "Best-Travel-Agency-in-Shirdi" },
        { place: "/images/keyword/15.jpg", text: "Shirdi to Mumbai Airport Cab", link: "Shirdi-to-Mumbai-Airport-Cab" },
        { place: "/images/keyword/16.jpg", text: "Kopargaon to Shirdi Cab", link: "Kopargaon-to-Shirdi-Cab" },
        { place: "/images/keyword/17.jpg", text: "Innova on Rent in Shirdi", link: "Innova-on-Rent-in-Shirdi" },
        { place: "/images/keyword/18.jpg", text: "Shirdi Sightseeing Cab", link: "Shirdi-Sightseeing-Cab" },
        { place: "/images/keyword/19.jpg", text: "Shirdi Darshan Taxi", link: "Shirdi-Darshan-Taxi" },
        { place: "/images/keyword/20.jpg", text: "Bus on Hire in Shirdi", link: "Bus-on-Hire-in-Shirdi" },
        { place: "/images/keyword/21.jpg", text: "Best Sedan Cab in Shirdi", link: "Best-Sedan-Cab-in-Shirdi" },
        { place: "/images/keyword/22.jpg", text: "Ertiga Car Hire in Shirdi", link: "Ertiga-Car-Hire-in-Shirdi" },
        { place: "/images/keyword/23.jpg", text: "Innova Crysta on Rent in Shirdi", link: "Innova-Crysta-on-Rent-in-Shirdi" },
        { place: "/images/keyword/24.jpg", text: "Mini Bus on Rent in Shirdi", link: "Mini-Bus-on-Rent-in-Shirdi" },
        { place: "/images/keyword/25.jpg", text: "Tempo Traveller Hire in Shirdi", link: "Tempo-Traveller-Hire-in-Shirdi" },
    ];











const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "35 Seater Bus on Rent in Shirdi",
  "image": "https://www.saishirdicabs.com/assets/images/35-seater-bus-on-rent-in-shirdi.webp",
  "description":
    "Book a 35 Seater Bus on Rent in Shirdi with Sai Shirdi Cabs for comfortable, spacious, and reliable group transportation. Our 35 Seater Bus is suitable for Sai Baba Darshan, Shirdi sightseeing, family trips, group tours, pilgrimages, weddings, corporate trips, school trips, airport transfers, railway station transfers, and outstation travel. Get a well-maintained bus with a professional driver, convenient pickup and drop locations, affordable rental service, and easy booking assistance.",
  "brand": {
    "@type": "Brand",
    "name": "Sai Shirdi Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "8517"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://www.saishirdicabs.com/35-seater-bus-on-rent-in-shirdi"
  }
};




    return (
        <div>

<Helmet>
  <title>35 Seater Bus on Rent in Shirdi | 35 Seater Bus Rental | +91 7776814559</title>

  <meta
    name="description"
    content="Book a 35 Seater Bus on Rent in Shirdi with Sai Shirdi Cabs for group travel, Sai Baba Darshan, sightseeing, weddings, corporate trips, school trips and outstation journeys. Get a spacious bus with professional driver and easy booking."
  />

  <meta
    name="keywords"
    content="35 Seater Bus on Rent in Shirdi, 35 Seater Bus Rental Shirdi, 35 Seater Bus Hire Shirdi, 35 Seater Tourist Bus Shirdi, 35 Seater Bus Booking Shirdi, 35 Seater Bus with Driver Shirdi, 35 Seater Bus for Outstation Shirdi, 35 Seater Bus for Family Trip Shirdi, 35 Seater Bus for Wedding Shirdi, 35 Seater Bus for Corporate Trip Shirdi, 35 Seater Bus for School Trip Shirdi"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>



            <section className="page-banner">
                <div className="page-banner-container">
                    <h2>
                        {cardData.keyword}
                    </h2>
                </div>
            </section>


















            <section>
                <div className="container-fluid p-0" >
                    <div className="row container-fluid px-md-2">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/88.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Sai Shirdi Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>

                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>





                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div className="service-card" key={index}>
                                        <div className="service-content">
                                            <h4>{service.name}</h4>
                                            <span className="line"></span>
                                            <p>{service.description}</p>
                                        </div>

                                        <div className="service-icon">
                                            <i className="fas fa-arrow-right"></i>
                                        </div>
                                    </div>
                                ))}
                            </div>

                            <div className="keyword-grid">
                                {cardData.tableData.flat().map((keyword, index) => (
                                    <div key={index} className="keyword-item">
                                        <span className="keyword-bullet">-</span>
                                        {keyword}
                                    </div>
                                ))}
                            </div>



                            <div id="why-choose-section" className="why-choose-section">

                                <h2 className="section-title text-dark">
                                    Why Choose <span>Sai Shirdi Cabs</span>
                                </h2>

                                <div className="bento-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div className="bento-card" key={index}>

                                            <div className="bento-number">
                                                {String(index + 1).padStart(2, "0")}
                                            </div>

                                            <h4>{item.WhyChooseheading}</h4>

                                            <p>{item.WhyChoosedescription}</p>

                                        </div>
                                    ))}
                                </div>

                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sai Shirdi Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title=""
                                                    subtitle=""
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fas fa-phone-alt"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+917776814559" className="pc-call">+91 7776814559 </a>
                                        </div>

                                        <div className="pc-list">
                                            <a href="tel:+919579032227" className="pc-call">+91 9579032227 </a>
                                        </div>
                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/91917776814559 "
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+917776814559 " className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-envelope"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@saishirdicabs.com" className="pc-email">
                                            booking@saishirdicabs.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-location-dot"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Sai Shirdi Cabs</strong><br />
                                            Sai Mandir Lene, Near Hotel Sai Kanhaiya,
                                            Shirdi,Tel - Rahata,Dist Ahilyanagar,
                                            Maharashtra, India - 423109




                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default ThirtyfiveSeaterBusOnRentInShirdi;